<div class="row align-items-center animated fadeIn">
  <div class="col-7">
    <h2 class="section-title">Meet Our Producers</h2>
    <p>
      Our connection with these outstanding brands goes beyond business – it's a true partnership based on mutual respect and shared values. In fact, an impressive 94% of the products available in the PFW market are sourced within a 170-mile radius of our warehouse, underlining our unwavering commitment to our local food ecosystem. These relationships are not just important, they are deeply personal to us, and we are genuinely honored to be part of this journey with our exceptional partners.
    </p>
  </div>

  <div class="col-5 d-flex justify-content-end">
    <img
      src="../../../assets/images/landing/producers/producers.webp"
      class="img-fluid"
      alt="Our producers image"
    />
  </div>
</div>

<div class="spacer-5"></div>

<div class="container-fluid">
  <div class="row">
    @defer (on immediate; when producersCards().length) {
      @if (producersCards()) {
        @for (producer of producersCards(); track producer.id) {
          @defer (on viewport; prefetch on immediate) {
            <div class="col-xl-3 col-lg-4 col-sm-6 animated fadeIn">
              <div class="card card-producer">
                <div class="card-body">
                  <img
                    (error)="handleImageError($event)"
                    src="{{ producer.img }}"
                    class="card-img"
                    alt="{{ producer.name }}"
                  />
                  <a [routerLink]="['/pages/producers/' + producer.detailUrl]" class="link-offset-2 link-underline link-underline-opacity-0">
                    <h3 class="card-title">{{ producer.name }}</h3>
                  </a>
                  <div class="card-detail mt-2" [innerHTML]="producer.description"></div>
                </div>
              </div>
            </div>
          } @placeholder {
            <div class="col-xl-3 col-lg-4 col-sm-6 animated fadeIn mb-3">
              <div class="card position-relative border p-3 row-gap-3" aria-hidden="true">
                <span class="placeholder bg-secondary col-12"></span>
                <span class="placeholder bg-secondary col-6"></span>
                <span class="placeholder bg-secondary col-6"></span>
                <div class="placeholder bg-secondary col-12" style="height: 100px;"></div>
                <div class="card-body">
                  <h5 class="card-title placeholder-glow">
                  <span class="placeholder bg-secondary col-6"></span>
                  </h5>
                  <p class="card-text placeholder-glow">
                  <span class="placeholder bg-secondary col-7"></span>
                  <span class="placeholder bg-secondary col-4"></span>
                  <span class="placeholder bg-secondary col-4"></span>
                  <span class="placeholder bg-secondary col-6"></span>
                  <span class="placeholder bg-secondary col-8"></span>
                  </p>
                  <a class="btn btn-secondary disabled placeholder col-12" aria-disabled="true"></a>
                </div>
              </div>
            </div>
          }
        }
      }
    }
  </div>
</div>
